<template>
  <div class="recommendations-page">
    <div class="recommendations-page__header">
      <span class="header-linear-secondary header-linear-secondary--animated">&nbsp;</span>
      <ProgressBarSecondary></ProgressBarSecondary>
    </div>
    <div class="recommendations-page__content">
      <div class="recommendations-page__content__header">Proposed Initiatives</div>
      <div class="row">
        <div class="col-1-of-2">
          <div class="cardCustom">
            <div class="cardCustom__side">
              <div class="cardCustom__header">
                <div class="cardCustom__header-text">Energy</div>
                <div class="cardCustom__header-info">
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-plus" />
                    <div class="tooltipCustom tooltipCustom--bottom">Add to Dashboard</div>
                  </div>
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-check-circle" />
                    <div class="tooltipCustom tooltipCustom--bottom">Mark as Solved</div>
                  </div>
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-info-circle" />
                    <div class="tooltipCustom tooltipCustom--bottom">Some Info</div>
                  </div>
                </div>
              </div>
              <div class="cardCustom__content align-items-center">
                <div class="cardCustom__icon">
                  <img src="../../assets/img/icons/ico_energy_green.png" alt="icon" />
                </div>
                <div class="cardCustom__content__texts">
                  <p class="cardCustom__content__text--bg">EV charging stations on property</p>
                </div>
                <div class="cardCustom__balanceInformation">
                  <span class="cardCustom__balanceInformation-value--bg cardCustom__balanceInformation-value--positive"
                    >+22</span
                  >
                  <img
                    src="../../assets/img/icons/vlLeafMark_green_noBG.png"
                    alt="leaf"
                    class="cardCustom__balanceInformation-img--bg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1-of-2">
          <div class="cardCustom">
            <div class="cardCustom__side">
              <div class="cardCustom__header">
                <div class="cardCustom__header-text">Air</div>
                <div class="cardCustom__header-info">
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-plus" />
                    <div class="tooltipCustom tooltipCustom--bottom">Add to Dashboard</div>
                  </div>
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-check-circle" />
                    <div class="tooltipCustom tooltipCustom--bottom">Mark as Solved</div>
                  </div>
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-info-circle" />
                    <div class="tooltipCustom tooltipCustom--bottom">Some Info</div>
                  </div>
                </div>
              </div>
              <div class="cardCustom__content align-items-center">
                <div class="cardCustom__icon">
                  <img src="../../assets/img/icons/ico_air_green.png" alt="icon" />
                </div>
                <div class="cardCustom__content__texts">
                  <p class="cardCustom__content__text--bg">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                </div>
                <div class="cardCustom__balanceInformation">
                  <span class="cardCustom__balanceInformation-value--bg cardCustom__balanceInformation-value--positive"
                    >+8</span
                  >
                  <img
                    src="../../assets/img/icons/vlLeafMark_green_noBG.png"
                    alt="leaf"
                    class="cardCustom__balanceInformation-img--bg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="textAlignCenter w-full">
          <span class="showAll">See all Initiatives Recommendations &darr;</span>
        </div>
      </div>

      <div class="recommendations-page__content__header">Consumption Analysis</div>
      <div class="row">
        <div class="col-1-of-2">
          <div class="cardCustom">
            <div class="cardCustom__side">
              <div class="cardCustom__header">
                <div class="cardCustom__header-text">Energy Consumption</div>
                <div class="cardCustom__header-info">
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-plus" />
                    <div class="tooltipCustom tooltipCustom--bottom">Add to Dashboard</div>
                  </div>
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-info-circle" />
                    <div class="tooltipCustom tooltipCustom--bottom">Some Info</div>
                  </div>
                </div>
              </div>
              <div class="cardCustom__content align-items-center">
                <div class="cardCustom__icon">
                  <img src="../../assets/img/icons/ico_highFluctuation_red.png" alt="icon" />
                </div>
                <div class="cardCustom__content__texts">
                  <p class="cardCustom__content__text--bg">Outliers, peaks or high fluctuation</p>
                </div>
                <div class="cardCustom__balanceInformation"></div>
              </div>
              <div class="cardCustom__footer">Jan 2021</div>
            </div>
          </div>
        </div>
        <div class="col-1-of-2">
          <div class="cardCustom cardCustom--activeBlur">
            <div class="cardCustom__side">
              <div class="cardCustom__header">
                <div class="cardCustom__header-text">Energy Consumption</div>
                <div class="cardCustom__header-info">
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-plus" />
                    <div class="tooltipCustom tooltipCustom--bottom">Add to Dashboard</div>
                  </div>
                  <div class="cardCustom__header-info__item">
                    <i class="fas fa-info-circle" />
                    <div class="tooltipCustom tooltipCustom--bottom">Some Info</div>
                  </div>
                </div>
              </div>
              <div class="cardCustom__content align-items-center">
                <div class="cardCustom__icon">
                  <img src="../../assets/img/icons/ico_compareYearAverages_red.png" alt="icon" />
                </div>
                <div class="cardCustom__content__texts">
                  <p class="cardCustom__content__text--bg">
                    Higher average consumption than <span class="font-weight-bold">last year</span>
                  </p>
                </div>
                <div class="cardCustom__balanceInformation">
                  <span class="cardCustom__balanceInformation-value--bg cardCustom__balanceInformation-value--negative"
                    >+47.2%</span
                  >
                </div>
              </div>
              <div class="cardCustom__footer">Jan 2021</div>
            </div>
            <div class="cardCustom__caption">
              <div class="cardCustom__caption-text">
                We have found that this year's consumption is on average higher than last year's consumption. We have
                compared the average, temperature- and humidity-adjusted monthly consumption values and found an average
                increase of about
                <span class="text-negative"> 47.18 % per month </span>compared to last year.
              </div>
              <div class="cardCustom__caption-button">
                <div class="btnCustom btnCustom-md btnCustom__confirm">Go to graph &rarr;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="textAlignCenter w-full">
          <span class="showAll">See all Consumption Analysis &darr;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBarSecondary from '@/components/Bars/ProgressBarSecondary';
export default {
  name: 'RecommendationsPage',
  components: { ProgressBarSecondary },
};
</script>

<style scoped></style>
